/* Fade in from bottom */
.fadeInUp {
  opacity: 0;
  animation: fadeInUp 0.8s ease-out forwards;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Fade in from top */
.fadeInDown {
  opacity: 0;
  animation: fadeInDown 0.8s ease-out forwards;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Fade in from left */
.fadeInLeft {
  opacity: 0;
  animation: fadeInLeft 1s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}

@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-100px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Fade in from right */
.fadeInRight {
  opacity: 0;
  animation: fadeInRight 1s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(100px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Scale in with bounce */
.scaleIn {
  opacity: 0;
  animation: scaleInBounce 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}

@keyframes scaleInBounce {
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  70% {
    transform: scale(1.05);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

/* Cinematic zoom with blur */
.cinematicZoom {
  opacity: 0;
  animation: cinematicZoom 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
}

@keyframes cinematicZoom {
  0% {
    opacity: 0;
    transform: scale(1.2);
    filter: blur(10px);
  }
  50% {
    opacity: 0.5;
    filter: blur(5px);
  }
  100% {
    opacity: 1;
    transform: scale(1);
    filter: blur(0);
  }
}

/* Simple fade in */
.fadeIn {
  opacity: 0;
  animation: fadeIn 0.8s ease-out forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Initial hidden state for elements that will be animated */
.hidden {
  opacity: 0;
}

